export default __webpack_public_path__ + "static/media/membership3.9fdad256.jpg";